import type { CSSProperties } from 'react'
import { Slide, ToastPosition } from 'react-toastify'

/** Applied to `ToastContainer` `style` — only on staff-area routes + desktop (see App.tsx). */
export const staffAreaDesktopToastContainerOffsetStyle: CSSProperties = {
  top: 50,
  left: 70,
}

export const toastConfig = (isMobile: boolean) => ({
  position: isMobile ? ('bottom-center' as ToastPosition) : ('top-left' as ToastPosition),
  autoClose: 2000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  transition: Slide,
  bodyStyle: {
    fontSize: '15px',
  },
  // Override the default toast container styles:
  toastStyle: {
    width: 'auto', // Allow the toast to size based on its content
    minWidth: 'auto', // Remove any fixed min-width
    maxWidth: 'none', // Remove the max-width limitation
  },
})
